export default __webpack_public_path__ + "static/media/harmoneyes-3.6d2f40a5.webp";